import type { WavespeedSpeechModelConfig } from '../types';

export const bytedanceConfigs: Record<string, WavespeedSpeechModelConfig> = {
  'seed-2.0-speech-tts': {
    // https://wavespeed.ai/zh-CN/models/bytedance/seed-speech-tts-2.0
    apiPath: '/bytedance/seed-speech-tts-2.0',
    enableTranslation: false,
    buildInput: ({ text, voice, providerOptions }) => {
      return {
        text: text,
        voice: voice,
        voice_instruction: providerOptions?.lyrics || '',
        // 可选参数
        output_format: typeof providerOptions?.output_format === 'string' ? providerOptions.output_format : 'mp3',
        sample_rate: typeof providerOptions?.sample_rate === 'number' ? providerOptions.sample_rate : 24000,
        speed: typeof providerOptions?.speed === 'number' ? providerOptions.speed : 1,
        volume: typeof providerOptions?.volume === 'number' ? providerOptions.volume : 1,
        pitch: typeof providerOptions?.pitch === 'number' ? providerOptions.pitch : 0,
        language: undefined,
      };
    },
  },
};